import type { RouteObject } from 'react-router';

import * as embedSearchWidgetLayoutHorizonRouteExports from 'modules/embedSearchWidget/layouts/layout/EmbedSearchWidgetLayout.horizon-route';
import * as embedSearchVolopsHorizonRouteExports from 'modules/embedSearchWidget/pages/volops/search/EmbedSearchWidgetSearchVolops.horizon-route';
import * as embedViewVolopHorizonRouteExports from 'modules/embedSearchWidget/pages/volops/view/EmbedSearchWidgetViewVolop.horizon-route';
import { horizonRouteToObject } from 'routing/utils/horizonRouteToObject';

import {
  embedSearchWidgetRouteGroup,
  embedSearchWidgetSearchVolopsRoute,
  embedSearchWidgetViewVolopRoute,
  embedSearchWidgetVolopsRouteGroup,
} from './embedSearchWidget.routes';

export const embedSearchWidgetRouteObjects = [
  {
    path: embedSearchWidgetRouteGroup.path,
    ...horizonRouteToObject(embedSearchWidgetLayoutHorizonRouteExports),
    children: [
      {
        path: embedSearchWidgetVolopsRouteGroup.path,
        children: [
          {
            path: embedSearchWidgetSearchVolopsRoute.relativePath,
            ...horizonRouteToObject(embedSearchVolopsHorizonRouteExports),
          },
          {
            path: embedSearchWidgetViewVolopRoute.fullPath,
            ...horizonRouteToObject(embedViewVolopHorizonRouteExports),
          },
        ],
      },
    ],
  },
] satisfies RouteObject[];
